// extracted by mini-css-extract-plugin
export default {"v-med":"(max-width: 768px)","v-med-large":"(max-width: 992px)","imageWrapper":"imageLinks__imageWrapper__XaIcT"};